import { HistoryFeed } from "src/components";
import { useMaterialListingHistoryQuery } from "src/routes/libraries/material-catalog/material-listing-page/components/MaterialListingHistoryPane.generated";
import { queryResult } from "src/utils";

export type MaterialListingHistoryPaneProps = { materialListingId: string };

/**
 * Audit trail for the listing, shown in the page's right sidebar.
 */
export function MaterialListingHistoryPane(props: MaterialListingHistoryPaneProps) {
  const { materialListingId } = props;
  const query = useMaterialListingHistoryQuery({ variables: { materialListingId } });

  return queryResult(query, {
    data: ({ materialListings }) => (
      <HistoryFeed historyItems={materialListings.entities.first?.history ?? []} renderAsCard={false} />
    ),
  });
}
